import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    document.addEventListener("turbo:before-visit", (event) => {
      if (!event.detail?.frame) {
        localStorage.setItem("previousPath", window.location.pathname);
      }
    });
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      return;
    }
    const previousPath = localStorage.getItem("previousPath");
    const currentPath = window.location.pathname.split("?")[0];
    if (
      (previousPath !== "/today/icebox" && currentPath == "/today") ||
      (previousPath === null && currentPath === "/today")
    ) {
      setTimeout(() => {
        this.element.focus();
      }, 100);
    }
    localStorage.removeItem("previousPath");
  }
}
